import { Dispatch, SetStateAction } from 'react';
import { current, produce } from 'immer';

import {
	getAncestorsObjectNodes,
	isMavenirNodeObject,
	recalculateCheckedNodes,
	toggleSelectedNodes,
} from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/FlatTreeMavenir/utils';

import { IFlatMoTreeNode } from '@interfaces/components/tree';

export const updateTreeNodeSelectionByIds = (
	data: IFlatMoTreeNode[],
	setData: Dispatch<SetStateAction<IFlatMoTreeNode[]>> | undefined,
	ids: string[],
	idType: 'id' | 'dbId',
) => {
	let myData: IFlatMoTreeNode[] = data;

	setData?.(
		produce((draftState) => {
			draftState.reduce((acc, node, parentIndex) => {
				const idValue = node[idType];

				if (idValue && ids.includes(idValue)) {
					const initCheckedCount = node.countOfChecked;

					toggleSelectedNodes({
						nodes: draftState,
						parentIndex,
					});

					const parentPath = node.path;

					const nodesIndexes = data.reduce((acc: number[], innerNode, index) => {
						return isMavenirNodeObject(innerNode) ? [...acc, index] : acc;
					}, []);

					const ancestorNodes = getAncestorsObjectNodes({
						parentPath,
						parentIndex,
						nodesIndexes,
						nodes: draftState,
					});

					recalculateCheckedNodes({
						ancestorNodes,
						initNode: node,
						initCheckedCount,
					});
				}

				return acc;
			}, []);

			myData = current(draftState);
		}),
	);

	return myData;
};

export const updateTreeNodeSelectionByNodeId = (
	data: IFlatMoTreeNode[],
	setData: Dispatch<SetStateAction<IFlatMoTreeNode[]>> | undefined,
	id: string,
) => {
	return updateTreeNodeSelectionByIds(data, setData, [id], 'id');
};
